import $store from '@/store/index'
import RTIL from '@/assets/js/rtc-client-ng'
import '@/assets/js/client'
import '@/assets/js/webrtcClient'
let WebRTC = null
let WebVoipRTC = null
const ownEvents = []
const previewList = []
let noStreamNeedCallback = {}

// previewType: 'rtc' | 'rtil'
// previewKey: string previewId
// previewContainer: 预览流的容器标识

function loadWebRtc () {
  WebRTC = new Window.RtcClient()
  WebRTC.init($store.state.initConfig.webRtcUrl)
  WebVoipRTC = new Window.WebRtcClient()
  WebVoipRTC.init($store.state.initConfig.webRtcUrl)
}

function startPreview (previewType, previewKey, previewContainer, previewStatus, origin) {
  const previewItem = previewList.find((k) => k.previewKey == previewKey)
  if (previewItem && previewItem.previewStream && previewItem.audioTrack && previewItem.audioTrack.length) {
    previewItem.previewContainers.includes(previewContainer) || previewItem.previewContainers.push(previewContainer)
    const key = previewType == 'voip' ? 'audioStream' : 'stream'
    return dispatch(key, {
      eventType: key,
      previewKey,
      previewContainer,
      previewStream: previewItem.previewStream,
      previewStatus: previewItem.previewStatus,
      audioTrack: previewItem.audioTrack,
      videoTrack: previewItem.videoTrack
    })
  } else if (previewItem) {
    noStreamNeedCallback[previewContainer] = {
      previewType, previewKey, previewContainer, origin
    }
    return (
      previewItem.previewContainers.includes(previewContainer) ||
      previewItem.previewContainers.push(previewContainer)
    )
  }
  previewList.push({
    previewKey,
    previewContainers: [previewContainer],
    previewStream: null,
    previewStatus: 1,
    audioTrack: null,
    videoTrack: null
  })

  dispatch('delay', { eventType: 'delay', previewKey })

  if (previewType == 'rtc') {
    rtcStartCall({ previewKey, previewContainer })
  }
  if (previewType == 'rtil') {
    rtilStartCall({ previewKey, previewContainer })
  }
  if (previewType == 'voip') {
    voipStartCall({ previewKey, previewContainer, previewStatus })
  }
}
function rtcStartCall ({ previewKey, previewContainer }) {
  const Item = previewList.find((k) => k.previewKey == previewKey)
  if (!Item) return
  WebRTC.startCall([previewKey], 'video', (result) => {
    if (result.type == 'success') {
      Item.previewStream = result.msg.mediaStream
      if (result.msg.mediaEvent?.track?.kind == 'audio') {
        Item.audioTrack = [result.msg.mediaEvent.track]
      }
      dispatch('stream', {
        eventType: 'stream',
        previewKey,
        previewContainer, // Item.previewContainers,
        previewStream: Item.previewStream,
        audioTrack: Item.audioTrack
      })
    } else if (result.type == 'wsNotConnect' || result.type == 'noLogin') {
      if (!Item.reStartCallNum) {
        Item.reStartCallNum = 1
      } else {
        Item.reStartCallNum += 1
      }
      if (Item.reStartCallNum < 10) {
        return setTimeout(rtcStartCall, 1000, { previewKey, previewContainer })
      }
    } else {
      dispatch('streamError', {
        eventType: 'streamError',
        previewKey
      })
    }
  })
}
function rtilStartCall ({ previewKey, previewContainer }) {
  const Item = previewList.find((k) => k.previewKey == previewKey)
  if (!Item) return
  // 定位问题，不要注释
  const RTILClient = new RTIL({ code: previewKey }, ({ action, result }) => {
    switch (action) {
      case 'stream':
        Item.previewStream = result.remoteStream.stream
        Item.audioTrack = result.remoteStream.stream.getAudioTracks()
        Item.videoTrack = result.remoteStream.stream.getVideoTracks()[0]
        dispatch('stream', {
          eventType: 'stream',
          previewKey,
          previewContainer, // : Item.previewContainers,
          previewStream: Item.previewStream,
          audioTrack: Item.audioTrack,
          videoTrack: Item.videoTrack,
          mediaType: result.mediaType,
          remoteUser: result.remoteUser
        })
        Object.keys(noStreamNeedCallback).forEach(keys => {
          const callbackItem = noStreamNeedCallback[keys]
          if (callbackItem.previewKey == Item.previewKey) {
            dispatch('stream', {
              eventType: 'stream',
              previewKey: callbackItem.previewKey,
              previewContainer: callbackItem.previewContainer, // : Item.previewContainers,
              previewStream: Item.previewStream,
              audioTrack: Item.audioTrack,
              videoTrack: Item.videoTrack,
              mediaType: result.mediaType,
              remoteUser: result.remoteUser
            })
            if (Item.previewStream && Item.audioTrack && Item.audioTrack.length) {
              delete noStreamNeedCallback[keys]
            }
          }
        })
        break
      case 'user-unpublished':
        Item.audioTrack = result.mediaType == 'audio' ? null : Item.audioTrack
        Item.videoTrack = result.mediaType == 'video' ? null : Item.videoTrack
        dispatch('user-unpublished', {
          eventType: 'user-unpublished',
          previewKey,
          previewContainer, // : Item.previewContainers,
          previewStream: Item.previewStream,
          audioTrack: Item.audioTrack,
          videoTrack: Item.videoTrack,
          mediaType: result.mediaType
        })
        break
      default:
        break
    }
  })
  Item.RTILClient = RTILClient
}
function voipStartCall ({ previewKey, previewContainer, previewStatus }) {
  const Item = previewList.find((k) => k.previewKey == previewKey)
  if (!Item) return
  dispatch('audioStream', {
    eventType: 'audioStream',
    previewContainer,
    previewStream: null,
    previewKey,
    previewStatus,
    audioTrack: null
  })
  WebVoipRTC.startCall(['0x' + previewKey.toUpperCase()], {
    [previewKey]: {
      peerId: previewKey,
      status: 1
    },
    type: 'audio'
  }, (result) => {
    if (result.type == 'success') {
      Item.previewStatus = 2
      Item.previewStream = result.msg.mediaStream
      Item.audioTrack = [result.msg.mediaStream]
      dispatch('audioStream', {
        eventType: 'audioStream',
        previewContainer,
        previewStream: Item.previewStream,
        previewKey,
        previewStatus: Item.previewStatus,
        audioTrack: Item.audioTrack
      })
    } else if (result.type == 'disconnected' || result.type == 'disconnectpeer' || result.type == 'failed' || result.type == 'closeVoip') {
      stopPreview('voip', previewKey, previewContainer)
    } else if (result.type === 'noHaveMediaDevice') {
      //
    }
  })
}
function stopPreview (previewType, previewKey, previewContainer) {
  const idx = previewList.findIndex((k) => k.previewKey == previewKey)
  if (idx > -1) {
    const previewItem = previewList[idx]
    let index = previewItem.previewContainers.indexOf(previewContainer)
    index > -1 && previewItem.previewContainers.splice(index, 1)
    if (!previewItem.previewContainers.length) {
      if (previewType == 'rtc') {
        WebRTC.stopCall(previewKey)
      }
      if (previewType == 'rtil') {
        previewItem.RTILClient?.destroy()
      }
      if (previewType == 'voip') {
        WebVoipRTC.stopCall('0x' + previewKey.toUpperCase())
      }
      // 仅当最后一个容器退出（流不再被任何容器共享）时，显式停止该 stream 的所有 track。
      // stopCall/RTILClient.destroy 未必停轨，残留的活动 MediaStreamTrack 会钉住 MediaStream，
      // 让已 detach 的 <video> 无法 GC（Detached HTMLVideoElement）。放在这里而非组件 beforeDestroy，
      // 是因为 previewStream 按 previewContainers 引用计数共享，组件层无条件 stop 会掐断其它存活容器 [Claude Code]
      releaseStreamTracks(previewItem)
      previewList.splice(idx, 1)
    }
    const key = previewType == 'voip' ? 'audioClear' : 'clear'
    dispatch(key, {
      eventType: key,
      previewKey,
      previewContainer
    })
  }
}
// 停止并断开 previewItem 上的所有媒体轨道引用，供 stopPreview 在流不再共享时调用。
// 优先停 previewStream.getTracks() 覆盖音视频全部轨道，并清空 stream/track 引用以便 GC [Claude Code]
function releaseStreamTracks (previewItem) {
  if (!previewItem) return
  const stream = previewItem.previewStream
  if (stream && typeof stream.getTracks === 'function') {
    stream.getTracks().forEach(track => track && typeof track.stop === 'function' && track.stop())
  }
  previewItem.previewStream = null
  previewItem.audioTrack = null
  previewItem.videoTrack = null
}

// 监听事件
function on (type, callback) {
  const list = ownEvents[type] || []
  list.push(callback)
  ownEvents[type] = list
}

// 发送事件
function dispatch (type, e) {
  const list = ownEvents[type] || []
  list.forEach((callback) => {
    callback(e)
  })
}

function remove (type, callback) {
  if (!ownEvents[type] || !ownEvents[type].length) return false
  const index = ownEvents[type].findIndex((i) => i == callback)
  if (index > -1) {
    ownEvents[type].splice(index, 1)
  }
}
export default {
  on,
  dispatch,
  remove,
  loadWebRtc,
  startPreview,
  stopPreview
}
